export default function Subheading({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="text-primary pb-1 font-semibold">{children}</div>
    </>
  );
}
